import { useState } from 'react';
import { useAssignableUsers, useCreateAssignment, useDeleteAssignment } from '../api/assignments';

interface Props {
  jobId: string;
  applicationId: string;
  interviewer: { assignmentId: string; user: { id: string; displayName: string } } | null;
}

export default function InterviewerManager({ jobId, applicationId, interviewer }: Props) {
  const { data: users } = useAssignableUsers();
  const create = useCreateAssignment(jobId);
  const remove = useDeleteAssignment(jobId);
  const [userId, setUserId] = useState('');
  const [error, setError] = useState<string | null>(null);
  const busy = create.isPending || remove.isPending;

  if (interviewer) {
    return (
      <div className="assign-block">
        {error && <div className="banner-error">{error}</div>}
        <div className="chips">
          <span className="chip chip-removable">
            {interviewer.user.displayName}
            <button className="chip-x" disabled={busy} aria-label="Remove interviewer"
              onClick={() => remove.mutate(interviewer.assignmentId, { onError: (e) => setError(e instanceof Error ? e.message : 'Failed') })}>×</button>
          </span>
        </div>
      </div>
    );
  }

  const add = () => {
    if (!userId) return;
    setError(null);
    create.mutate({ type: 'INTERVIEWER', userId, applicationId }, {
      onError: (e) => setError(e instanceof Error ? e.message : 'Failed'),
      onSuccess: () => setUserId(''),
    });
  };

  return (
    <div className="assign-block">
      {error && <div className="banner-error">{error}</div>}
      <div className="assign-add">
        <select value={userId} onChange={(e) => setUserId(e.target.value)} disabled={busy}>
          <option value="">Assign an interviewer…</option>
          {(users ?? []).map((u) => <option key={u.id} value={u.id}>{u.displayName} ({u.email})</option>)}
        </select>
        <button className="btn-ghost" onClick={add} disabled={busy || !userId}>Assign</button>
      </div>
    </div>
  );
}
